<template>
  <div class="page-container">
    <div class="forgot-password-container">
      <div class="header">Forgot password?</div>

      <v-form class="signup-form" v-model="isFormValid">
        <v-text-field v-model="email" class="email" ref="email" autocomplete="username" label="Email" :rules="emailRules" hide-details="auto"></v-text-field>
        <v-btn type="submit" :disabled="!isFormValid || loading" :loading="loading" @click="submit" class="reset-button" color="#5774E7" width="300px" height="38px">Reset password</v-btn>
      </v-form>

      <a class="bottom-text" @click="$router.push('login')">Back to Login</a>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    isFormValid: true,
    loading: false,
    email: "",
    emailRules: [
      (value) => !!value || "Required.",
      (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
    ],
  }),

  methods: {
    submit() {
      this.loading = true;
      const data = {email: this.email, url: window.location.origin + "/#"}
      axios
        .post(this.$store.state.serverURL + "/users/forgotpassword", data, { withCredentials: true })
        .then((res) => {
          this.loading = false;
          this.$router.push("sendpasswordlink");
        })
        .catch((err) => {
          this.loading = false;
          this.$toast.error(err.request.responseText, { position: "bottom-right", timeout: 7500 });
        });
    },
  },
};
</script>

<style scoped>
.forgot-password-container {
  width: 380px;
  height: 320px;
  position: absolute;
  top: calc(50% - 225px);
  left: calc(50% - 190px);
  background-color: white;
  box-shadow: 0px 2px 4px rgba(0, 41, 199, 0.2);
  border-radius: 4px;
  display: flex;
  justify-content: center;
}
.email {
  width: 300px;
  position: absolute;
}

.signup-form {
  position: absolute;
  top: 130px;
  width: 300px;
}
.header {
  width: 100%;
  height: 100px;
  background-color: #5774e7;

  color: white;

  position: absolute;
  padding-top: 35px;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  /* identical to box height, or 133% */

  text-align: center;
}

.reset-button {
  position: absolute;
  top: 80px;
  color: white;
}

.bottom-text {
  position: absolute;
  top: 275px;

  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 16px;
  /* identical to box height, or 123% */

  text-align: center;

  /* Indigo / 400 */

  color: #5774e7;
}
</style>
